(() => {
 const setup = (root = document) => {
  root.querySelectorAll('[data-bolero-card-carousel]').forEach(section => {
   const track = section.querySelector('[data-bolero-carousel-track]');
   const controls = section.querySelector('[data-bolero-carousel-controls]');
   if (!track || !controls || track.dataset.ready) return;
   track.dataset.ready = 'true';
   const previous = controls.querySelector('[data-bolero-carousel-prev]');
   const next = controls.querySelector('[data-bolero-carousel-next]');
   const status = controls.querySelector('[data-bolero-carousel-status]');
   const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
   const update = () => {
    const maximum = track.scrollWidth - track.clientWidth;
    const position = Math.abs(track.scrollLeft);
    controls.hidden = maximum <= 2;
    previous.disabled = position <= 2;
    next.disabled = position >= maximum - 2;
    const bounds = track.getBoundingClientRect();
    const children = [...track.children];
    const visible = children.map((child, index) => ({bounds: child.getBoundingClientRect(), index})).filter(item => Math.min(item.bounds.right, bounds.right) - Math.max(item.bounds.left, bounds.left) > item.bounds.width * .5);
    if (visible.length && status) {
     const start = visible[0].index + 1;
     const end = visible[visible.length - 1].index + 1;
     const message = status.dataset.template.replace('[start]', start).replace('[end]', end).replace('[total]', children.length);
     if (status.textContent !== message) status.textContent = message;
    }
   };
   const move = direction => {
    const child = track.firstElementChild;
    if (!child) return;
    const style = getComputedStyle(track);
    const step = child.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
    track.scrollBy({left: direction * step * (style.direction === 'rtl' ? -1 : 1), behavior: reducedMotion.matches ? 'auto' : 'smooth'});
   };
   previous.addEventListener('click', () => move(-1));
   next.addEventListener('click', () => move(1));
   track.addEventListener('keydown', event => {
    if (event.target !== track) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
     event.preventDefault();
     move(event.key === 'ArrowRight' ? 1 : -1);
    }
   });
   let scheduled = false;
   track.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
   }, {passive:true});
   const resize = new ResizeObserver(update);
   resize.observe(track);
   section.addEventListener('shopify:section:unload', () => resize.disconnect(), {once:true});
   update();
  });
  root.querySelectorAll('[data-bolero-filters]').forEach(panel => {
   if (panel.dataset.ready) return;
   panel.dataset.ready = 'true';
   const scope = panel.closest('[data-bolero-collection]') || panel.parentElement;
   const grid = scope.querySelector('[data-bolero-grid]');
   if (!grid) return;
   const cards = [...grid.querySelectorAll('[data-product-card]')];
   cards.forEach((card, index) => card.dataset.original = index);
   const count = scope.querySelector('[data-bolero-count]');
   const empty = scope.querySelector('[data-bolero-empty]');
   const update = () => {
    const values = Object.fromEntries([...panel.querySelectorAll('select,input')].map(el => [el.name, el.value]));
    const ordered = [...cards].sort((a, b) => {
     if (values.sort === 'price-up') return Number(a.dataset.price) - Number(b.dataset.price);
     if (values.sort === 'price-down') return Number(b.dataset.price) - Number(a.dataset.price);
     if (values.sort === 'name') return a.dataset.title.localeCompare(b.dataset.title);
     return Number(a.dataset.original) - Number(b.dataset.original);
    });
    let visible = 0;
    ordered.forEach(card => {
     const matched = (!values.family || card.dataset.family === values.family) && (!values.format || card.dataset.format === values.format) && (!values.stock || (values.stock === 'orderable' ? card.dataset.stock !== 'unavailable' : card.dataset.stock === values.stock)) && (!values.maxprice || Number(card.dataset.price) <= Number(values.maxprice) * 100);
     card.hidden = !matched;
     if (matched) visible++;
     grid.appendChild(card);
    });
    if (count) count.textContent = count.dataset.template.replace('[count]', visible);
    if (empty) empty.hidden = visible > 0;
   };
   panel.addEventListener('change', update);
   panel.addEventListener('input', event => { if (event.target.type === 'number') update(); });
   panel.querySelector('[data-clear-filters]')?.addEventListener('click', () => { panel.querySelectorAll('select,input').forEach(el => el.value = ''); update(); });
  });
  root.querySelectorAll('[data-bolero-sticky]').forEach(sticky => {
   if (sticky.dataset.ready) return;
   sticky.dataset.ready = 'true';
   const productInfo = document.querySelector('product-info');
   if (!productInfo) return;
   const getForm = () => productInfo.querySelector('product-form form');
   const stickyButton = sticky.querySelector('button');
   const refresh = () => {
    const source = getForm()?.querySelector('[name="add"]');
    const variant = getForm()?.querySelector('[name="id"]');
    const price = productInfo.querySelector('.price .price-item--sale, .price .price-item--regular');
    if (source && stickyButton) {
     const nextDisabled = source.disabled || !variant?.value;
     const nextText = source.querySelector('span')?.textContent.trim() || source.textContent.trim();
     if (stickyButton.disabled !== nextDisabled) stickyButton.disabled = nextDisabled;
     if (stickyButton.textContent !== nextText) stickyButton.textContent = nextText;
    }
    const stickyPrice = sticky.querySelector('[data-sticky-price]');
    const salePrice = productInfo.querySelector('.price__sale .price-item--sale');
    const regularPrice = productInfo.querySelector('.price__regular .price-item--regular');
    const visiblePrice = salePrice?.getClientRects().length ? salePrice : regularPrice;
    if (stickyPrice && (visiblePrice || price)) {
     const nextPrice = (visiblePrice || price).textContent.trim();
     if (stickyPrice.textContent !== nextPrice) stickyPrice.textContent = nextPrice;
    }
   };
   stickyButton?.addEventListener('click', () => { const form = getForm(); if (form && !stickyButton.disabled) form.requestSubmit(); });
   let refreshScheduled = false;
   new MutationObserver(() => { if (!refreshScheduled) { refreshScheduled = true; requestAnimationFrame(() => { refreshScheduled = false; refresh(); }); } }).observe(productInfo, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','value']});
   const observer = new IntersectionObserver(entries => {
    const visible = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom <= 0;
    sticky.classList.toggle('is-visible', visible);
    document.body.classList.toggle('b-has-sticky-buy', visible);
   }, {threshold:0});
   const source = productInfo.querySelector('product-form');
   if (source) observer.observe(source);
   refresh();
  });
  root.querySelectorAll('[data-bolero-feed]').forEach(feed => {
   const slot = feed.querySelector('.b-feed-slot');
   const check = () => {
    const images = [...slot.querySelectorAll('img')];
    const hasImage = images.some(img => img.complete && img.naturalWidth > 0);
    const hasFrame = slot.querySelector('iframe');
    const hasPost = slot.querySelector('a[href*="instagram.com/p/"],a[href*="instagram.com/reel/"]');
    if (hasImage || (hasFrame && hasPost)) feed.hidden = false;
    images.forEach(img => { img.loading = 'lazy'; img.addEventListener('error', () => { if (!images.some(i => i.naturalWidth > 0)) feed.hidden = true; }, {once:true}); });
   };
   new MutationObserver(check).observe(slot, {childList:true,subtree:true});
   slot.addEventListener('load', check, true);
   check();
  });
 };
 document.addEventListener('DOMContentLoaded', () => setup());
 document.addEventListener('shopify:section:load', event => setup(event.target));
 document.addEventListener('click', event => {
  const mobileLink = event.target.closest('.b-mobile-nav a');
  if (mobileLink) mobileLink.closest('details')?.removeAttribute('open');
  document.querySelectorAll('.b-shop-menu[open],.b-mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
 });
 document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.b-shop-menu[open],.b-mobile-menu[open]').forEach(menu => { menu.removeAttribute('open'); menu.querySelector('summary')?.focus(); }); });
})();
